// src/components/Dashboard/MarkdownRenderer.js
import React from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownRenderer = ({ children }) => {
  const components = {
    p: ({ children }) => <p className="mb-2">{children}</p>,
    ul: ({ children }) => <ul className="list-disc pl-5 mb-2">{children}</ul>,
    ol: ({ children }) => <ol className="list-decimal pl-5 mb-2">{children}</ol>,
    li: ({ children }) => <li className="mb-1">{children}</li>,
    a: ({ href, children }) => (
      <a href={href} className="text-blue-600 underline hover:text-blue-800">
        {children}
      </a>
    ),
  };

  return (
    <ReactMarkdown components={components}>
      {children.replace(/\\n/g, '\n')}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
